var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"image-viewer-container"},[_c('v-img',{attrs:{"contain":"","src":_vm.url}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }